import { render, staticRenderFns } from "./IcoMessengerLogo.vue?vue&type=template&id=3a52792e"
import script from "./IcoMessengerLogo.vue?vue&type=script&lang=js"
export * from "./IcoMessengerLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports